export interface CappedGapBreakdownItems {
  visibleItems: string[];
  remainingCount: number;
}

export const capGapBreakdownItems = (items: string[], limit = 6): CappedGapBreakdownItems => {
  if (items.length <= limit) {
    return {visibleItems: items, remainingCount: 0};
  }

  return {
    visibleItems: items.slice(0, limit),
    remainingCount: items.length - limit,
  };
};
